import { useMemo } from "react";
import { useQuoteData } from "./useQuoteData";

export const useCartTitle = (customText?: string) => {
    const { quoteId, quotePetCount: petCount = 0 } = useQuoteData();

    return useMemo(() => {
        if (quoteId && petCount > 0) return "Finish My Plan";

        return customText || "Click For Price";
    }, [petCount, customText, quoteId]);
};
